import { render, staticRenderFns } from "./restore-deleted-messages-gb-whatsapp.vue?vue&type=template&id=427e7d17"
import script from "./restore-deleted-messages-gb-whatsapp.vue?vue&type=script&lang=js"
export * from "./restore-deleted-messages-gb-whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports